/** Chuỗi của màn Biên bản cuộc họp (ADR-0126). */
export const viBienBan = {
  bienBan: {
    tieuDe: 'Biên bản cuộc họp',
    timNhan: 'Tìm phiên',
    timPlaceholder: 'Tìm theo tiêu đề hoặc tên tệp',
    locTrangThai: 'Lọc theo trạng thái',
    tatCaTrangThai: 'Tất cả trạng thái',
    taiBanGhi: 'Tải bản ghi âm',
    taiBanGhiDauTien: 'Tải bản ghi âm đầu tiên',
    rongThat: 'Chưa có biên bản nào',
    rongThatMo: 'Tải bản ghi âm hoặc ghi âm ngay để máy chép lời, phân biệt người nói và tóm tắt.',
    rongLoc: 'Không có phiên phù hợp',
    khongCoQuyen: 'Bạn chưa được xem biên bản cuộc họp',
    khongCoQuyenMo: 'Nhờ quản trị tổ chức cấp quyền xem biên bản.',
    bangCaption: 'Danh sách phiên biên bản cuộc họp',
    loiDanhSach: 'Không tải được danh sách. {{loi}}',
    dangHien: 'Đang hiện {{so}} phiên',
    dangHienCon: 'Đang hiện {{so}} phiên, còn nữa',
    cot: {
      tieuDe: 'Tiêu đề',
      thoiLuong: 'Thời lượng',
      soNguoiNoi: 'Số người nói',
      trangThai: 'Trạng thái',
      nguoiTao: 'Người tạo',
      ngayTao: 'Ngày tạo',
    },
    trangThai: {
      QUEUED: 'Đang chờ',
      TRANSCRIBING: 'Đang chép lời',
      SUMMARIZING: 'Đang tóm tắt',
      DONE: 'Hoàn tất',
      FAILED: 'Lỗi',
    },
    tomTatLoiNgan: 'Tóm tắt lỗi',
    moPhien: 'Xem biên bản',
    doiTen: 'Đổi tên phiên',
    thuLaiPhien: 'Thử lại',
    xuatWord: 'Xuất Word',
    xuatVanBan: 'Xuất văn bản',
    xoaPhien: 'Xoá phiên',
    daXuat: 'Đã tải {{ten}}',
    loiXuat: 'Không tải được tệp. {{loi}}',
    daXoa: 'Đã xoá phiên {{ten}}.',
    daDoiTen: 'Đã đổi tên phiên.',
    daThuLai: 'Đã đưa phiên vào hàng chờ xử lý lại.',
    xacNhanXoa: {
      tieuDe: 'Xoá phiên "{{ten}}"?',
      than: 'Bản ghi âm, bản chép lời và tóm tắt của phiên này sẽ bị xoá vĩnh viễn. Không hoàn tác được.',
      nut: 'Xoá phiên',
    },
    hopDoiTen: {
      tieuDe: 'Đổi tên phiên',
      nhan: 'Tiêu đề',
      nut: 'Lưu tiêu đề',
      loiTrong: 'Nhập tiêu đề cho phiên.',
    },
    chiTiet: {
      veDanhSach: 'Biên bản cuộc họp',
      loiTai: 'Không tải được phiên. {{loi}}',
      khongThay: 'Không tìm thấy phiên này',
      khongThayMo: 'Phiên có thể đã bị xoá.',
      thongTin: '{{thoiLuong}} · {{ngay}}',
    },
    phat: {
      nhan: 'Trình phát bản ghi âm',
      phat: 'Phát',
      tamDung: 'Tạm dừng',
      lui: 'Lùi 5 giây',
      toi: 'Tới 5 giây',
      thanhTua: 'Vị trí đang phát',
      tocDo: 'Tốc độ phát',
      phimTat: 'Phím tắt: K phát hoặc tạm dừng, J lùi 5 giây, L tới 5 giây.',
      khongPhatDuoc: 'Không phát được bản ghi âm. Bản chép lời vẫn dùng được.',
      loiTai: 'Không lấy được bản ghi âm. {{loi}} Bản chép lời vẫn dùng được.',
    },
    loi: {
      tieuDe: 'Bản chép lời',
      vungCuon: 'Nội dung bản chép lời',
      rong: 'Chưa có bản chép lời',
      rongXuLy: 'Bản chép lời sẽ hiện ở đây khi máy chép xong',
      loiTai: 'Không tải được bản chép lời. {{loi}}',
      canhBao: 'Nhãn người nói có thể chưa chính xác, nên nghe lại',
      veDoanDangPhat: 'Về đoạn đang phát',
      tuaToi: 'Phát từ {{tg}}',
      suaDoan: 'Sửa đoạn lúc {{tg}}',
      daSua: 'Đã sửa',
      nhanNoiDung: 'Nội dung đoạn',
      nhanNguoiNoi: 'Người nói của đoạn',
      luuDoan: 'Lưu đoạn',
      loiTrong: 'Nhập nội dung cho đoạn, hoặc Huỷ để giữ nguyên.',
      daLuuDoan: 'Đã lưu đoạn.',
      chuaRo: 'Chưa rõ người nói',
      nguoiNoiSo: 'Người nói {{so}}',
    },
    nguoiNoi: {
      tieuDe: 'Người nói',
      rong: 'Danh sách người nói sẽ có khi máy chép xong',
      nhanTen: 'Tên của {{nhan}}',
      datTen: 'Đặt tên',
      noiTrong: 'Thời lượng nói',
      daLuu: 'Đã đổi tên người nói.',
    },
  },
  bienBanTai: {
    tieuDe: 'Tải bản ghi âm',
    theTep: 'Chọn tệp',
    theGhiAm: 'Ghi âm ngay',
    keoTha: 'Kéo thả tệp vào đây hoặc bấm để chọn',
    keoThaMo: 'Âm thanh hoặc video, tối đa {{so}} MB',
    boTep: 'Bỏ tệp {{ten}}',
    nhanTieuDe: 'Tiêu đề',
    nhanNgonNgu: 'Ngôn ngữ',
    ngonNgu: { auto: 'Tự nhận diện', vi: 'Tiếng Việt', en: 'Tiếng Anh' },
    nhanSoNguoi: 'Số người nói',
    goiYSoNguoi: 'Để trống nếu chưa biết. Biết đúng số người thì nhãn chính xác hơn.',
    loiChuaChon: 'Chọn tệp ghi âm hoặc ghi âm trước khi gửi.',
    loiTrongTieuDe: 'Nhập tiêu đề cho phiên.',
    loiSaiDinhDang: 'Tệp này không phải âm thanh hoặc video. Chọn tệp MP3, WAV, M4A, AAC, OGG, OPUS, FLAC, WEBM, MP4 hoặc MOV.',
    loiQuaLon: 'Tệp lớn hơn {{so}} MB. Cắt nhỏ hoặc nén tệp rồi tải lại.',
    loiTepRong: 'Tệp rỗng. Kiểm tra lại tệp rồi chọn lại.',
    gui: 'Gửi bản ghi âm',
    dangGui: 'Đang gửi...',
    tienTrinh: 'Đang tải lên {{so}}%',
    nhanTienTrinh: 'Tiến trình tải lên',
    huyTai: 'Huỷ tải lên',
    daGui: 'Đã gửi bản ghi âm. Máy đang xử lý.',
    tieuDeGhiAm: 'Ghi âm {{luc}}',
  },
  bienBanGhiAm: {
    batDau: 'Bắt đầu ghi âm',
    dangXinQuyen: 'Đang xin quyền micro...',
    dung: 'Dừng ghi',
    lamLai: 'Ghi lại từ đầu',
    dangGhi: 'Đang ghi âm',
    daGhi: 'Đã ghi {{tg}}. Nghe lại trước khi gửi.',
    nhanNgheLai: 'Nghe lại bản vừa ghi',
    loi: {
      KHONG_HO_TRO: 'Trình duyệt này không ghi âm được. Mở bằng Chrome, Edge, Firefox hoặc Safari bản mới, hoặc tải tệp ghi âm có sẵn.',
      KHONG_BAO_MAT: 'Chỉ ghi âm được khi mở trang qua HTTPS. Mở lại bằng địa chỉ https:// hoặc tải tệp ghi âm có sẵn.',
      TU_CHOI: 'Micro đang bị từ chối. Bấm biểu tượng khoá trên thanh địa chỉ, cho phép micro rồi thử lại.',
      KHONG_CO_THIET_BI: 'Không thấy micro nào. Cắm micro rồi thử lại, hoặc tải tệp ghi âm có sẵn.',
      DANG_BAN: 'Micro đang bị ứng dụng khác dùng. Đóng ứng dụng đó rồi thử lại.',
      KHONG_CO_TIENG: 'Bản ghi không có dữ liệu. Thử ghi lại, hoặc tải tệp ghi âm có sẵn.',
      KHAC: 'Không mở được micro. Thử lại, hoặc tải tệp ghi âm có sẵn.',
    },
  },
  bienBanXuLy: {
    nhan: 'Tiến trình xử lý',
    buoc: {
      QUEUED: 'Đang chờ',
      TRANSCRIBING: 'Chép lời',
      SUMMARIZING: 'Tóm tắt',
      DONE: 'Hoàn tất',
    },
    moTa: {
      QUEUED: 'Phiên đang xếp hàng. Máy nhận dạng xử lý lần lượt từng tệp, trang tự cập nhật.',
      TRANSCRIBING: 'Máy đang chép lời và phân biệt người nói. Tệp dài có thể mất vài phút, trang tự cập nhật.',
      SUMMARIZING: 'Bản chép lời đã có, máy đang tóm tắt.',
    },
    loiMacDinh: 'Xử lý không thành công. Thử lại sau ít phút.',
    tieuDeLoi: 'Xử lý không thành công',
    maLoi: 'Mã lỗi: {{ma}}',
    thuLai: 'Thử lại xử lý',
  },
  bienBanTomTat: {
    tieuDe: 'Tóm tắt',
    trangThai: {
      NONE: 'Chưa có',
      PENDING: 'Đang tóm tắt',
      DONE: 'Đã có',
      FAILED: 'Lỗi',
    },
    daSuaTay: 'Đã sửa tay',
    tongQuan: 'Tổng quan',
    yChinh: 'Ý chính',
    quyetDinh: 'Quyết định',
    viecCanLam: 'Việc cần làm',
    phuTrach: 'Phụ trách: {{ten}}',
    han: 'Hạn: {{han}}',
    khongCoMuc: 'Không có',
    suaTay: 'Sửa tóm tắt',
    tomTatLai: 'Tóm tắt lại',
    taoTomTat: 'Tạo tóm tắt',
    dangTomTat: 'Máy đang tóm tắt, trang tự cập nhật.',
    choChepLoi: 'Tóm tắt sẽ có sau khi máy chép lời xong',
    chuaCo: 'Phiên này chưa có tóm tắt',
    loiMacDinh: 'Tóm tắt không thành công. Bấm Tóm tắt lại để thử lần nữa.',
    daGuiTomTatLai: 'Đã gửi yêu cầu tóm tắt lại.',
    daLuu: 'Đã lưu tóm tắt.',
    xacNhanLai: {
      tieuDe: 'Tóm tắt lại phiên này?',
      than: 'Bản tóm tắt đã sửa tay sẽ bị thay bằng bản máy tạo mới. Phần đã sửa không lấy lại được.',
      nut: 'Tóm tắt lại',
    },
    hop: {
      tieuDe: 'Sửa tóm tắt',
      tongQuan: 'Tổng quan',
      yChinh: 'Ý chính',
      quyetDinh: 'Quyết định',
      moiDong: 'Mỗi dòng một mục.',
      viecCanLam: 'Việc cần làm',
      noiDungViec: 'Nội dung việc {{so}}',
      nguoiPhuTrach: 'Người phụ trách việc {{so}}',
      hanViec: 'Hạn của việc {{so}}',
      phViec: 'Việc cần làm',
      phNguoi: 'Người phụ trách',
      phHan: 'Hạn',
      themViec: 'Thêm việc',
      boViec: 'Bỏ việc {{so}}',
      loiTongQuan: 'Nhập tổng quan cho biên bản.',
      loiViec: 'Nhập nội dung việc, hoặc bỏ dòng này.',
      nut: 'Lưu tóm tắt',
    },
  },
} as const;
